import { defineElement } from "./gw.js";
class PageNav extends HTMLElement {
  connectedCallback() {
    this.links = [...this.querySelectorAll("a")];
    this.targetIds = this.links.map((link) =>
      link.getAttribute("href").replace("#", ""),
    );
    this.targets = this.targetIds.map((id) => document.getElementById(id));
    this.linkMap = this.links.reduce((acc, link, index) => {
      acc[this.targetIds[index]] = link;
      return acc;
    }, {});
    this.initObserver();
  }

  initObserver() {
    const options = {
      rootMargin: "-10% 0px -90% 0px",
      // Only trigger when target is in top 10% of viewport
      threshold: 0,
    };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const link = this.linkMap[entry.target.id];
          if (link) {
            this.links.forEach((l) => l.classList.remove("is-active"));
            link.classList.add("is-active");
          }
        }
      });
    }, options);
    this.targets.forEach((target) => {
      this.observer.observe(target);
    });
  }
}
defineElement("page-nav", PageNav);
